module.exports = __webpack_public_path__ + "media/interface-124464.1868e98d.mp3";